<template>
	<div id="content" class="col">
		<ClipLoader :loading="!loaded" color="#5FB0E2" size="150px" class="p-5"></ClipLoader>
		<div v-show="loaded">
			<div v-if="task && task.item_type == 'content_task'">
				<div v-if="pages && page > 0" class="content_nav_top border-bottom p-3" style="clear: both;">

					<div class="float-left" v-if="page > 0 && pages.length > 0"><button type="button"
							class="btn btn-primary otu-blue-bg border-0 p-2 contentNav" @click="navigate('previous')">&lt;
							<span>{{ $t('previous') }}</span></button></div>
					<div class="float-right" v-if="pages.length > 0 && !lastPage"><button type="button"
							class="btn btn-primary otu-blue-bg border-0 p-2 contentNav" @click="navigate('next')"><span>{{
								$t('next') }}</span> &gt;</button></div>
					<div class="float-right" v-if="lastPage"><button type="button"
							class="btn btn-primary otu-blue-bg border-0 p-2" @click="complete">{{ $t('continue') }}</button>
					</div>
					<div class="float-right mr-2" v-if="currentPage.type == 'slides'"><button title="Full Screen"
							type="button" class="btn btn-primary otu-blue-bg border-0 p-2 px-3 contentNav"
							@click="fullScreen()"><font-awesome-icon :icon="['fas', 'arrows-alt']" /></button></div>
					<div class="text-center pt-2 whereami w-100" v-html="whereAmI"></div>
				</div>

				<div v-if="page > 0" class="wrap" style="overflow: auto; min-height: 600px;">
					<h2 v-if="title != ''">{{ title }}</h2>
					<h2 v-else>{{ moduleTitle }}</h2>
					<div v-if="task.item.text_to_speech">



						<!-- <div class="float-right mr-2"><button type="button" class="btn btn-primary otu-blue-bg border-0 p-2"
								@click="textToSpeech()" v-b-tooltip :title="$t('play')"><font-awesome-icon
									icon="headphones" /></button></div>
									<p v-if="this.$store.state.programs.isPlaying">Something is playing</p>
									<p v-else>Something is not playing</p> -->
						<div class="float-right mr-2">
							<button v-if="this.$store.state.programs.isPlaying" type="button" class="btn btn-primary otu-blue-bg border-0 p-2"
								@click="textToSpeechStop()" v-b-tooltip :title="$t('stop')"><font-awesome-icon
									icon="stop" /></button>
							<button v-else type="button" class="btn btn-primary otu-blue-bg border-0 p-2"
								@click="textToSpeech()" v-b-tooltip :title="$t('play')"><font-awesome-icon
									icon="headphones" /></button>
						</div>
						<!-- <h2>{{ $t('create_account.table_selfguided_step1')}}</h2> -->
									<!-- <div class="float-right mr-2">Speed
						<select v-model="selected">
							<option value=0.5>Slow</option>
							<option value=1>Medium</option>
							<option value=2>Fast</option>
						</select>
					</div> -->
						<div class="dropdown float-right mr-2">
							<button class="btn btn-primary otu-blue-bg border-0 p-2 dropdown-toggle" type="button" id="dropdownMenuButton" v-b-tooltip :title="$t('choose_speed')"
								data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								
								{{$t('speed')}} {{ selected }}x
							</button>
							<div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
								<span class="dropdown-item" @click="selectPlayBackSpeed(0.5)" :class="{ 'active': selected === 0.5 }">0.5x</span>
								<span class="dropdown-item" @click="selectPlayBackSpeed(1)" :class="{ 'active': selected === 1 }">1x</span>
								<span class="dropdown-item" @click="selectPlayBackSpeed(2)" :class="{ 'active': selected === 2 }">2x</span>
							</div>
						</div>
						<!-- end code for dropdown -->

					</div>

					<div v-if="currentPage.type == 'slides'" class="contentClass fr-view slide" id="slideContainer">
						<div v-if="inFullScreen" class="slideToolBar p-2">
							<!-- <h2 class="float-left">{{ moduleTitle }}</h2> -->
							<button v-if="pages.length > 0" type="button" :disabled="page <= 1"
								class="btn btn-primary otu-blue-bg border-0 p-2 contentNav float-left ml-2"
								@click="navigate('previous')">&lt; <span>{{ $t('previous') }}</span></button>
							<button v-if="pages.length > 0" type="button" :disabled="lastPage"
								class="btn btn-primary otu-blue-bg border-0 p-2 contentNav float-left ml-2"
								@click="navigate('next')"><span>{{ $t('next') }}</span> &gt;</button>
							<div class="float-left p-2" v-html="whereAmI"></div>
							<button type="button" class="btn btn-primary otu-blue-bg border-0 p-2 contentNav float-right"
								@click="exitFullScreen()"><font-awesome-icon :icon="['fas', 'times']" size="lg" /> {{
									$t('exit') }}</button>
							<div class="clear w-100" style="clear:both"></div>
						</div>
						<div v-html="htmlContent" @click="navigate('next')" class="slideImage"></div>
					</div>
					<div v-else v-html="htmlContent" class="contentClass fr-view"></div>

					<Resources v-if="Object.keys(currentPage.resources).length > 0 && (Object.keys(pages).length == 0)"
						:files="currentPage.resources" :task_id="task_id" :stage_id="stage_id" />
				</div>

				<div class="wrap" v-if="page == 0">
					<h2>{{ $t('courses.toc') }}</h2>
					<h3>{{ moduleTitle }}</h3>

					<div v-html="moduleBody"></div>

					<div class="mb-3">
						<button type="button" class="btn btn-primary otu-blue-bg border-0 p-2" @click="navigate('next')">{{
							$t('courses.content_begin') }}</button>
						<button v-if="checkContinueNonViewed && !ckeckContinueAllViewed" type="button"
							class="btn btn-primary otu-blue-bg border-0 p-2 ml-3" @click="lastaccessed()">{{ $t('continue')
							}}</button>
					</div>


					<div><b-form-select class="w-50" v-model="page" :options="jumpToOptions"></b-form-select></div>

					<Resources v-if="Object.keys(currentPage.resources).length > 0 && (Object.keys(pages).length > 0)"
						:files="currentPage.resources" :task_id="task_id" :stage_id="stage_id" />

				</div>

				<div v-if="pages && page > 0" class="content_nav border-top p-3 mt-4" style="clear: both;">
					<div class="float-left" v-if="page > 0 && pages.length > 0"><button type="button"
							class="btn btn-primary otu-blue-bg border-0 p-2 contentNav" @click="navigate('previous')">&lt;
							<span>{{ $t('previous') }}</span></button></div>
					<div class="float-right" v-if="pages.length > 0 && !lastPage"><button type="button"
							class="btn btn-primary otu-blue-bg border-0 p-2 contentNav" @click="navigate('next')"><span>{{
								$t('next') }}</span> &gt;</button></div>
					<div class="float-right" v-if="lastPage"><button type="button"
							class="btn btn-primary otu-blue-bg border-0 p-2" @click="complete">{{ $t('continue') }}</button>
					</div>
					<div class="text-center pt-2 whereami w-100" v-html="whereAmI"></div>
				</div>
			</div>
			<div v-else>
				<div v-if="survey_result.complete">
					<div class="wrap contentClass fr-view">
						<h2>{{ this.task.item.title }}</h2>
						<h3>Thank you for completing the survey!</h3>
					</div>

					<!-- <div class="content_nav border-top p-3 mt-4" style="clear: both;">
						<div class="float-right"><button type="button" class="btn btn-primary otu-blue-bg border-0 p-2" @click="complete">{{ $t('continue')}}</button></div>
					</div> -->
				</div>
				<div class="m-4">
					<div class="float-right"><button type="button" class="btn btn-primary otu-blue-bg border-0 p-2"
							@click="complete">{{ $t('continue') }}</button></div>
				</div>
				<SurveyObject :enrol_id="enrollment.id" :task_id="task.id" :survey_result="survey_result"
					show_breadcrumb="true" @complete="complete()" :loaded="loaded" ref="survey" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Vue from 'vue'

import { EventBus, mapNotificationEventActions } from '@/lib/events.js';
import { mapCommonFilters } from '@/lib/filters.js';
import { errHandler } from '@/lib/handlers';
import { mapDebugActions } from '@/lib/debug';

import SurveyObject from '@/components/therapy/SurveyObject.vue';


export default {
	name: 'TherapyContent',
	components: {
		ClipLoader: () => import('vue-spinner/src/ClipLoader'),
		Resources: () => import('@/components/Resources'),
		SurveyObject
	},
	props: ['task_id', 'page_position'],
	data() {
		return {
			loaded: false,
			page: 0,
			inFullScreen: false,
			synth: null,
			selected: 1,
			// speechCheck: true
		}
	},
	watch: {
		/*
		$route: function() {
			this.debugObject ({params: this.$route.params});
			this.loaded = false;
			this.page = 0;
			this.debugMessage("Route change");
			this.loadContent();
		},
		*/
		page() { // Mark Page as Viewed
			let current = this.page - 1;
			if (current > -1) {

				this.debugObject({ pages: this.pages, current })
				let page_id = (this.pages && Object.keys(this.pages).length > 0) ? this.pages[current].id : this.parent_id;
				let path_id = (this.pages && Object.keys(this.pages).length > 0) ? this.parent_id + '/' + this.pages[current].id : this.parent_id;

				this.pageView({ enrol_id: this.enrollment.id, stage_id: this.stage_id, task_id: this.task_id, page_id: path_id });
				this.$store.commit('setPageViewed', { task_id: this.task_id, page_id: page_id });
			} else if (current == -1) {
				this.loadContent(); // reload TOC
			}

			this.$nextTick(function () {
				if (this.currentPage && this.currentPage.type && this.currentPage.type != 'slides') this.scrollToTop();
			});
		}
	},
	mounted() {
		this.debugMessage('<<MOUNTED>>');
		this.debugObject({ params: this.$route.params })
		this.loadContent();

		if (this.page_position) {
			this.page = this.page_position;
		}

		document.onkeydown = evt => {
			evt = evt || window.event;
			if (evt.keyCode == 37 && this.page > 0) this.navigate('previous');
			else if (evt.keyCode == 39 && !this.lastPage) this.navigate('next');

			if (evt.keyCode === 27 || evt.keyCode === 81) this.exitFullScreen();
		};
		// Add event listener for page unload
		// window.addEventListener('beforeunload', this.cleanupSpeechSynthesis);
	},
	computed: {
		enrollment() {
			return this.$store.state.programs.enrollment;
		},
		stage_id() {
			return this.$route.params.stage_id;
		},
		task() {
			return (this.$store.state.programs.stage) ? this.$store.state.programs.stage.tasks[this.task_id] : null;
		},
		stage_tasks() {
			return (this.$store.state.programs.stage) ? this.$store.state.programs.stage.tasks : null;
		},
		parent_id() {
			return (this.task) ? this.task.item_id : null;
		},
		pages() {
			return (this.task && this.task.item_type == 'content_task' && this.task.item && this.task.item.pages && Object.keys(this.task.item.pages).length > 0) ? this.task.item.pages : {};
		},
		lastPage() {
			return ((Object.keys(this.all_pages).length == this.page) || (Object.keys(this.all_pages).length == 0) || !this.all_pages) ? true : false;
		},
		moduleTitle() {
			if (this.$store.state.programs.stage.tasks[this.task_id])
				return this.$store.state.programs.stage.tasks[this.task_id].item.title;
		},
		moduleBody() {
			return (this.$store.state.programs.stage.tasks[this.task_id] && this.$store.state.programs.stage.tasks[this.task_id].item && this.$store.state.programs.stage.tasks[this.task_id].item.body != null) ? this.$store.state.programs.stage.tasks[this.task_id].item.body : '';
		},
		all_pages() {
			return (this.$store.state.programs.pages && this.$store.state.programs.pages[this.task_id]) ? _.orderBy(this.$store.state.programs.pages[this.task_id], 'position', 'asc') : [];
		},
		currentPage() {
			return ((this.page - 1) >= 0 && this.all_pages[this.page - 1]) ? this.all_pages[this.page - 1] : this.task.item;
		},
		title() {
			return this.currentPage.title;
		},
		htmlContent() {
			return this.currentPage.body;
		},
		htmlContentForSpeech() {
			return (this.currentPage && this.currentPage.body_text) ? this.currentPage.body_text : '';
		},
		whereAmI() {
			if (this.all_pages && this.all_pages.length > 0) {
				let type = this.$t('courses.page');
				if (this.task.item.type == 'slideshows') type = this.$t('courses.slide');
				return type + ' ' + this.page + ' ' + this.$t('courses.of') + ' ' + this.all_pages.length;
			}
			return ' &nbsp; ';
		},
		contentClass() {
			return (this.task.item.type == 'slideshows') ? 'text-center' : '';
		},
		jumpToOptions() {

			let options = [];
			let pages = this.all_pages;
			let keys = Object.keys(pages);
			let vm = this;

			options.push({ value: 0, text: this.$t('courses.jump') });

			keys.forEach(function (key, index) {
				let slideNumber = index + 1;
				let title = (pages[key].title) ? pages[key].title : vm.$t('courses.slide') + ' ' + slideNumber;
				let disabled = (pages[key].viewed || slideNumber == 1) ? false : true;
				options.push({ value: index + 1, text: title, disabled: disabled });
			});

			return options;
		},
		ckeckContinueAllViewed() {
			let pages = this.all_pages;
			let keys = Object.keys(pages);
			let vm = this;
			let check_temp = true;
			keys.forEach(function (key, index) {
				if (!pages[key].viewed && check_temp) {
					check_temp = false;
				}
			});
			return check_temp;
		},
		checkContinueNonViewed() {
			let pages = this.all_pages;
			let keys = Object.keys(pages);
			return (pages[0] && pages[0].viewed) ? true : false;
		},
		survey_result() {
			return this.$store.state.surveys.survey_result;
		}
	},
	methods: {
		...mapActions(['fetchContent', 'fetchStage', 'pageView', 'fetchSurveyResult']),
		...mapDebugActions,
		scrollToTop() {
			let top = document.querySelector('#content').getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop)
			window.scrollTo({ top: top, behavior: 'smooth' });
		},
		loadContent() {
			this.debugMessage("<<loadContent>>");
			this.debugMessage(new Date());
			this.debugObject({ task: this.task, params: this.$route.params });
			if (this.task) {
				this.debugMessage(this.task.item_type);
				if (this.task.item_type == 'content_task') {
					this.debugMessage(">> CONTENT TASK");

					this.debugObject({ task_pages: this.task.item.pages, computed_pages: this.pages });
					if (this.$store.state.programs.pages[this.task_id]) {
						this.page = (this.pages && Object.keys(this.pages).length == 0) ? 1 : 0;
						this.loaded = true;
						return true;
					}

					if (this.pages && Object.keys(this.pages).length > 0) { // Loads Child Content
						this.debugMessage('Loads Child Content');
						let vm = this;
						let keys = Object.keys(this.pages);
						keys.forEach(function (k) {
							let page = vm.pages[k].id;
							if (page) {
								let content_path = vm.parent_id + '/' + String(page);
								vm.fetchContent({ enrol_id: vm.enrollment.id, stage_id: vm.stage_id, task_id: vm.task_id, page_id: content_path })
									.then((v) => vm.loaded = true).catch((err) => console.error(err));
							}
						});

					} else { // Displays Single Item Content
						this.debugMessage('Loads Single Item Content');
						this.fetchContent({ enrol_id: this.enrollment.id, stage_id: this.stage_id, task_id: this.task_id, page_id: this.parent_id })
							.then((v) => {
								this.page = 1;
								this.loaded = true;
							}).catch((err) => console.error(err));
					}
				} else if (this.task.item_type == 'survey_task') {
					this.debugMessage(">> SURVEY TASK");

					this.fetchSurveyResult({ enrol_id: this.enrollment.id, task_id: this.task.id }).then((v) => {
						if (this.$route.params.task_id == this.task.id) {
							this.pageView({ enrol_id: this.enrollment.id, stage_id: this.stage_id, task_id: this.task_id, page_id: this.survey_result.survey_id });
						}
						this.$nextTick(function () {
							if ('survey' in this.$refs) {
								if (this.task.item_type == 'survey_task') {
									this.$refs.survey.loadSurvey();
									this.loaded = true;
									this.$refs.survey.resetPosition();
								}
							} else {

							}
						});
					});
				}
			}
		},
		navigate(dir) {
			if (dir == 'next') {
				if (!this.lastPage) this.page = this.page + 1;
			}
			else if (dir == 'previous' && (this.page - 1) >= 0) this.page = this.page - 1;

			if (this.page == 0) this.inFullScreen = false;

			this.$nextTick(function () {
				if (this.currentPage && this.currentPage.type && this.currentPage.type != 'slides') this.scrollToTop();
			});
		},
		complete() {

			// Mark task as Completed and Percentage to 100% in $store
			this.$store.state.programs.stage.tasks[this.task_id].complete = true;
			this.$store.state.programs.stage.tasks[this.task_id].complete_percent = 1;

			// fetchStage and check for unlocked content
			this.fetchStage({ enrol_id: this.enrollment.id, stage_id: this.stage_id }).then((v) => {

				let vm = this;
				let taskIndex = null;
				let tasks = _.orderBy(this.stage_tasks, 'position', 'asc'); // Order Tasks to check whats next

				tasks.forEach(function (t, i) {
					if (t.id == vm.task_id) taskIndex = i;
				});

				// Check to see if there is another task, and it's unlocked
				let noMoreTasks = true;
				if ((taskIndex + 1) < tasks.length) {
					noMoreTasks = false
					taskIndex = taskIndex + 1;
					let nextTask = tasks[taskIndex];
					this.debugObject({ msg: "NextTask", nextTask, unlocked: nextTask.unlocked });

					if (nextTask.unlocked) {
						let vm = this;
						this.debugObject({ msg: "Pushing Route!", enrol_id: this.enrollment.id, stage: this.stage_id, task_id: nextTask.id });
						this.$router.push({ name: 'therapy.content', params: { enrol_id: this.enrollment.id, stage: this.stage_id, task_id: nextTask.id } }, function () {
							vm.debugObject({ msg: 'route complete', params: vm.$route.params });
						});
					}
					else noMoreTasks = true;
				}

				if (noMoreTasks) this.$router.push({ name: 'therapy.display', params: { enrol_id: this.enrollment.id } });
			});
		},
		lastaccessed() {
			let pages = this.all_pages;
			let keys = Object.keys(pages);
			let vm = this;
			let check_temp = true;
			keys.forEach(function (key, index) {
				if (!pages[key].viewed && check_temp) {
					// vm.page = index + 1; if want to jump to the next page
					vm.page = index;
					check_temp = false;
				}
			});
		},
		fullScreen() {
			$('#slideContainer').addClass('fullscreen-slide');
			this.inFullScreen = true;
		},
		exitFullScreen() {
			$('#slideContainer').removeClass('fullscreen-slide');
			this.inFullScreen = false;
		},
		textToSpeech() {
			this.synth = window.speechSynthesis;
			//cancel anything that is playing
			this.synth.cancel();
			let ourText = this.htmlContentForSpeech;
			const utterThis = new SpeechSynthesisUtterance(ourText);
			utterThis.rate = Number(this.selected);
			this.synth.speak(utterThis);
			this.$store.state.programs.isPlaying = true;

			// this.speechCheck = false;
		},
		textToSpeechStop() {
			if(this.synth === null || this.synth===undefined)
				this.synth = window.speechSynthesis;
			this.synth.cancel();
			this.$store.state.programs.isPlaying = false;
			// this.speechCheck = true;
		},
		selectPlayBackSpeed(speed){
			this.selected = speed
		},
		// cleanupSpeechSynthesis() {
		// 	// Stop speech synthesis upon page unload
		// 	this.textToSpeechStop();
    	// }


	},
	// beforeDestroy() {
    // // Remove event listener to avoid memory leaks
    // 	window.removeEventListener('beforeunload', this.cleanupSpeechSynthesis);
  	// }
}
</script>

<style>
.fr-view img.fr-dib {
	margin: 5px auto;
	display: block;
	float: none;
	vertical-align: top;
}

.fr-view img.fr-dib.fr-fil {
	margin-left: 0;
	text-align: left;
}

.fr-view img.fr-dib.fr-fir {
	margin-right: 0;
	text-align: right;
}

.fr-view span.fr-img-caption.fr-dii {
	display: inline-block;
	float: none;
	vertical-align: bottom;
	margin-left: 5px;
	margin-right: 5px;
	max-width: calc(100% - (2 * 5px));
}

.fr-view span.fr-img-caption.fr-dii.fr-fil {
	float: left;
	margin: 5px 5px 5px 0;
	max-width: calc(100% - 5px);
}

.fr-view span.fr-img-caption.fr-dii.fr-fir {
	float: right;
	margin: 5px 0 5px 5px;
	max-width: calc(100% - 5px);
}

.fr-view span.fr-img-caption {
	position: relative;
	max-width: 100%;
}

.fr-view .fr-img-caption {
	text-align: center;
}

img.fr-rounded,
.fr-img-caption.fr-rounded img {
	border-radius: 10px;
	-moz-border-radius: 10px;
	-webkit-border-radius: 10px;
	-moz-background-clip: padding;
	-webkit-background-clip: padding-box;
	background-clip: padding-box;
}

img.fr-bordered {
	-webkit-box-sizing: content-box;
	box-sizing: content-box;
}

img.fr-bordered,
.fr-img-caption.fr-bordered img {
	border: solid 5px #CCC;
}

.fr-view img {
	position: relative;
	max-width: 100%;
}

.fr-view.slide {
	text-align: center;
}

.fr-view.slide img {
	width: 100%;
	max-width: 800px;
}

img.fr-shadow,
.fr-img-caption.fr-shadow img {
	-webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, .12), 0 1px 1px 1px rgba(0, 0, 0, .16);
	box-shadow: 0 1px 3px rgba(0, 0, 0, .12), 0 1px 1px 1px rgba(0, 0, 0, .16);
}

@media only screen and (max-width:500px) {
	button.contentNav {
		padding-left: 15px !important;
		padding-right: 15px !important;
	}

	button.contentNav span {
		display: none;
	}
}

.fullscreen-slide {
	z-index: 9999;
	height: 100%;
	width: 100%;
	position: fixed;
	top: 0;
	left: 0;
	overflow: hidden;
	background-color: rgba(0, 0, 0, 0.7);
}

.fr-view.slide.fullscreen-slide img {
	width: 99%;
	height: 100%;
	max-width: 99%;
	max-height: 100%;
	object-fit: contain;
}

.fr-view.slide.fullscreen-slide .slideToolBar {
	position: absolute;
	bottom: 0px;
	left: 0px;
	width: 100%;
	background: #000;
	color: #FFF;
}

.fr-view.slide.fullscreen-slide .slideToolBar h2 {
	color: #fff;
	text-align: center
}

.fr-view.slide.fullscreen-slide .slideImage {
	height: calc(100% - 60px);
}</style>
